import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../../global/env';
import { AuditLogReportRequest, EnrollmentReportItem } from '../../model/auditlogreports';

const fetchApproverEnrollments = async (request: AuditLogReportRequest): Promise<EnrollmentReportItem[]> => {
  const url = Config.auditReportsBaseURL + 'enrollment/approvers';
  const { data } = await axios.post(url, request);
  //@ts-ignore
  const rows: EnrollmentReportItem[] = data.map(item => new EnrollmentReportItem(item));
  return rows;
}

const useApproverEnrollments = (request: AuditLogReportRequest) => {
  return useQuery<EnrollmentReportItem[], Error>(['ApproverEnrollments', request], () => fetchApproverEnrollments(request));
}

export default useApproverEnrollments;